<template>
  <div class="page-link" @click="onClick">
    <q-icon name="chevron_right" />{{ label }}
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    route: String,
  },

  methods: {
    onClick() {
      this.$router.push(this.route);
    },
  },
};
</script>

<style>
.page-link {
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
